import { createIcon, IconProps } from "@chakra-ui/react";

type IconSize = "sm" | "md" | "lg";

interface CloudCheckmarkIconProps extends IconProps {
    size?: IconSize;
}

const BaseCloudCheckmarkIcon = createIcon({
    displayName: "CloudCheckmarkIcon",
    viewBox: "0 0 24 24",
    defaultProps: {
        fill: "none",
        stroke: "currentColor"
    },
    path: (
        <>
            <path
                d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 1 0 0-10Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="m6 12 2.25 3L12 10" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </>
    )
});

export const CloudCheckmarkIcon = ({ size = "md", ...props }: CloudCheckmarkIconProps) => {
    const boxSizeMap: Record<IconSize, string> = {
        sm: "4",
        md: "6",
        lg: "8"
    };

    return <BaseCloudCheckmarkIcon boxSize={boxSizeMap[size]} {...props} />;
};
